import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  IconButton,
  Paper,
  Box,
  Divider
} from '@mui/material'
import { Close, Check, PersonAdd } from '@mui/icons-material'

const FranchiseOptionsDialog = ({ open, onClose, onExistingOwner, onNewOwner }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '8px',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
        }
      }}
    >
      <DialogTitle sx={{ bgcolor: '#f8f9fa', py: 2 }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h5" fontWeight="500" color="primary.main">
            Select Franchise Option
          </Typography>
          <IconButton 
            onClick={onClose} 
            size="small"
            sx={{ 
              bgcolor: 'rgba(0, 0, 0, 0.04)',
              '&:hover': { 
                bgcolor: 'rgba(0, 0, 0, 0.08)', 
                color: 'error.main' 
              } 
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Grid>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Paper 
            elevation={0}
            onClick={onExistingOwner}
            sx={{ 
              border: '1px solid #e0e0e0', 
              borderRadius: '8px', 
              p: 2.5,
              cursor: 'pointer',
              transition: 'all 0.2s',
              '&:hover': { 
                borderColor: 'primary.main', 
                bgcolor: 'rgba(25, 118, 210, 0.04)',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              }
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Check 
                  sx={{ 
                    color: 'primary.main', 
                    bgcolor: 'rgba(25, 118, 210, 0.1)', 
                    borderRadius: '50%',
                    p: 0.6,
                    fontSize: 24
                  }} 
                />
              </Grid>
              <Grid item xs>
                <Typography variant="h6" gutterBottom>
                  1. I already have a franchise owner
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Create outlet with existing franchise owner
                </Typography>
              </Grid>
            </Grid>
          </Paper>
          
          <Paper 
            elevation={0}
            onClick={onNewOwner}
            sx={{ 
              border: '1px solid #e0e0e0', 
              borderRadius: '8px',
              p: 2.5,
              cursor: 'pointer',
              transition: 'all 0.2s',
              '&:hover': { 
                borderColor: 'primary.main', 
                bgcolor: 'rgba(25, 118, 210, 0.04)',
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
              }
            }}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <PersonAdd 
                  sx={{ 
                    color: 'primary.main', 
                    bgcolor: 'rgba(25, 118, 210, 0.1)', 
                    borderRadius: '50%',
                    p: 0.6,
                    fontSize: 24
                  }} 
                />
              </Grid>
              <Grid item xs>
                <Typography variant="h6" gutterBottom>
                  2. Create a new franchise owner
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Set up a new franchise owner for this outlet
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, pt: 1 }}>
        <Button 
          onClick={onClose} 
          variant="outlined" 
          size="medium"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FranchiseOptionsDialog
